import { render } from "./CollectionDetailedSearchOfficialGazette.vue?vue&type=template&id=e44b0fce&scoped=true&ts=true"
import script from "./CollectionDetailedSearchOfficialGazette.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchOfficialGazette.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchOfficialGazette.vue?vue&type=style&index=0&id=e44b0fce&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e44b0fce"]])

export default __exports__